export var IntlType;
(function (IntlType) {
    IntlType["singleLine"] = "singleLine";
    IntlType["multipleLine"] = "multipleLine";
})(IntlType || (IntlType = {}));
